'use client'

import { useAuth } from '@/lib/auth/AuthProvider'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'
import Navigation from './Navigation'

export default function ConditionalNavigation() {
  const { user, isOnboardingComplete, isLoading } = useAuth()
  const pathname = usePathname()
  // 🔥 REMOVED: Squad completeness state - not needed for navigation access
  // Navigation access is determined solely by onboarding completion

  // Check if current page is an auth/setup page
  const isAuthPage =
    pathname === '/login' ||
    pathname === '/register' ||
    pathname?.startsWith('/auth/') ||
    pathname === '/terms' ||
    pathname === '/privacy' ||
    pathname === '/terms-of-service' ||
    pathname === '/privacy-policy'

  const isSetupPage =
    pathname === '/verify-phone' ||
    pathname === '/verify-age' ||
    pathname === '/select-country' ||
    pathname === '/onboarding'

  // 🔥 SIMPLIFIED: Only check if onboarding is complete
  // Once onboarding is done, user should have full navigation access
  // All other checks (phone, age, country) are already part of onboarding flow
  const isFullySetup = user && isOnboardingComplete

  // Only show navigation if:
  // 1. Not on auth/setup pages
  // 2. User completed onboarding OR on public home page
  const shouldShowNavigation =
    !isAuthPage &&
    !isSetupPage &&
    !isLoading &&
    (isFullySetup || // Onboarding complete users
      (!user && pathname === '/')) // Public home page for non-authenticated users

  if (shouldShowNavigation) {
    return <Navigation />
  }

  return null
}
